module.exports = __webpack_public_path__ + "static/media/default-avatar-v2.487d1a1d.svg";